import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import UploadFile from "@mui/icons-material/UploadFile";
import { useSnackbar } from "notistack";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { NestiFyzExportPreview } from "../nestifyz/NestifyzExportPreview";
import { UploadNestiFyzMigrationFile } from "../nestifyz/UploadNestifyzMigrationFile";

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.CustomControl
 */
export const NestiFyzMigrationTool = ({ CustomControl }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { data: entitlements } = useMyEntitlements();
  const [uploadedFile, setUploadedFile] = useState(
    /** @type {{name: string, export: import("../nestifyz/parseExport").NestiFyzExport}|null} */ (null)
  );

  const onSuccess = (fileData) => {
    setUploadedFile(fileData);
  };

  const onFailure = () => {
    enqueueSnackbar("An error occurred attempting to parse the NestiFyz export file. Please try again.", {
      variant: "error",
    });
  };

  return (
    <FullScreenDialog title="NestiFyz Migration" Icon={UploadFile} CustomControl={CustomControl}>
      {!uploadedFile && (
        <Box pb={1}>
          <Alert severity="info">Upload a NestiFyz export file to begin the migration.</Alert>
        </Box>
      )}
      {!uploadedFile && <UploadNestiFyzMigrationFile onSuccess={onSuccess} onFailure={onFailure} />}
      {uploadedFile && (
        <Box>
          {entitlements && !entitlements.isMember && (
            <Box pb={1}>
              <Alert severity="warning">
                Images over 5MB in size will be skipped during migration. Upgrade to premium to remove this limit.
              </Alert>
            </Box>
          )}
          <Alert severity="success" sx={{ mb: 2 }}>
            Loaded {uploadedFile.name}
          </Alert>
          <NestiFyzExportPreview NestiFyzExport={uploadedFile.export} />
        </Box>
      )}
    </FullScreenDialog>
  );
};
